
import "./AdminWebTrackerPage.css";
import Grid from "@mui/material/Grid";
import Box from '@mui/material/Box';
import { useState, useRef, useEffect } from "react";
import AdminHeaderLinks from "../../components/adminHeaderLinks/AdminHeaderLinks.jsx"
import { updateUserRequest } from "../../services/wisdomServices/userService";
import { getSessionItem } from "../../utils/helper/session";
import { Button } from "primereact/button";
import { getTeamMembers } from "../../services/wisdomServices/managerService";
import { AutoComplete } from "primereact/autocomplete";
import { Can } from "../../security/Can.jsx";
import { PERMISSIONS } from "../../security/permissions.generated.js";

/**
 * @function AdminWebTrackerPage
 * @returns {JSX.Element} - admin web tracker management page
 */
function AdminWebTrackerPage () {
    const debounceRef = useRef(null);
    const [users, setUsers] = useState([]);
    const [searchString, setSearchString] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    let [webTrackerStatus, setWebTrackerStatus] = useState(false);
    
    const loggedUser = getSessionItem("User")

    const handleSelectChange = (user) => {
        setSelectedUser(user)
        setWebTrackerStatus(user.webtrackerEnabled)
    };
  
    const handleWebTrackerSelectChange = (event) => {
        const value = event.target.value === "true";
        setWebTrackerStatus(value);
    }
    

    /**
     * @async
     * @function UpdateUserWebTrackerStatus
     * @description - updates the selected user's Web Tracker status
     */
    const UpdateUserWebTrackerStatus = async() => {
        try {
            let userInformation = {
                isWebtrackerEnabled: webTrackerStatus
            }
    
            await updateUserRequest(selectedUser.id, userInformation)
            
        } catch (error) {
            console.error(error)
        }
        
    }

    const getUsers = async(event) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(async () => {
            let usersList = []
            try {
                const getUsersResponse = await getTeamMembers(loggedUser.id, false, event.query, 1, 1000)
                for (const user of getUsersResponse.data) {
                    usersList.push({
                        id: user.id,
                        name: user.fullName,
                        webtrackerEnabled: user.webtrackerEnabled
                    })
                }
                
            setUsers(usersList)
            } catch (error) {
                console.error(error)
            }
        }, 1000)
    }

    useEffect(() => {
        return () => {
            if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            }
        };
    }, []);

    return (
        <div className="settingsContainer">
            <AdminHeaderLinks/>
            {  
                <Box sx={{ flexGrow: 1 }} className="settingsBody">
                    <Grid container spacing={2}>
                        <Grid size={10}>
                            <h3 className="settingsLabel">Web Tracker</h3>

                        </Grid>
                        <Grid size={10} className="update-fields">
                            <AutoComplete 
                                value={searchString}
                                onChange={(e) => setSearchString(e.value)}
                                onSelect={(e) => handleSelectChange(e.value)}
                                suggestions={users}
                                completeMethod={getUsers}
                                field="name"
                                placeholder="Search user..."
                            />
                            {selectedUser && (
                                <div className="webtracker-options-box">
                                    <select 
                                    className="web-tracker-status-select"
                                    onChange={handleWebTrackerSelectChange}
                                    value={webTrackerStatus}
                                    >
                                        <option key='2' value="true">On</option>
                                        <option key='3' value="false">Off</option>
                                    </select>
                                    <Can permission={PERMISSIONS.usersById_patch}>
                                        <Button 
                                            label="Save"
                                            severity="success"
                                            title="Save user web tracker status"
                                            onClick={UpdateUserWebTrackerStatus}
                                            disabled={webTrackerStatus == 'default'}
                                        />
                                    </Can>
                                </div>
                            )}
                        </Grid>
                        
                    </Grid>
                </Box>
            }
        </div>
    );
}

export default AdminWebTrackerPage;